import { Box } from "../../box";
import { forwardRef, useMemo } from "react";
import { CrossButton, embedIconButton } from "../../button";
import { cssModule, isNil, mergeProps, normalizeSize, useMergedRefs, useSlots } from "../../shared";
import { useResponsiveValue } from "../../styling";
import { Text } from "../../typography";
import { embeddedIconSize } from "../../icons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultElement = "div";
export function InnerTag({
  active,
  as = DefaultElement,
  children,
  disabled,
  fluid,
  focus,
  forwardedRef,
  hover,
  onRemove,
  size,
  variant = "solid",
  ...rest
}) {
  const fluidValue = useResponsiveValue(fluid);
  const sizeValue = useResponsiveValue(size);
  const ref = useMergedRefs(forwardedRef);
  const {
    counter,
    dot,
    "end-icon": endIcon,
    icon,
    text
  } = useSlots(children, useMemo(() => ({
    _: {
      defaultWrapper: Text
    },
    counter: {
      color: "inherit",
      disabled,
      pushed: true,
      size: sizeValue
    },
    dot: {
      className: "o-ui-tag-dot",
      disabled
    },
    "end-icon": {
      className: "o-ui-tag-end-icon",
      size: embeddedIconSize(sizeValue)
    },
    icon: {
      className: "o-ui-tag-start-icon",
      size: embeddedIconSize(sizeValue)
    },
    text: {
      className: "o-ui-tag-text",
      color: "inherit",
      size: sizeValue
    }
  }), [sizeValue, disabled]));
  const removeMarkup = !isNil(onRemove) && embedIconButton( /*#__PURE__*/_jsx(CrossButton, {
    "aria-label": "Remove"
  }), {
    "aria-label": "Remove",
    className: "o-ui-tag-remove-button",
    condensed: true,
    onClick: onRemove,
    size: sizeValue
  });
  return /*#__PURE__*/_jsxs(Box, { ...mergeProps(rest, {
      as,
      className: cssModule("o-ui-tag", variant, dot && "has-dot", icon && "has-start-icon", endIcon && "has-end-icon", removeMarkup && "has-remove-button", fluidValue && "fluid", active && "active", focus && "focus", hover && "hover", normalizeSize(sizeValue)),
      disabled,
      ref
    }),
    children: [icon, dot, text, endIcon, counter, removeMarkup]
  });
}
InnerTag.defaultElement = DefaultElement;
export const Tag = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerTag, { ...props,
  forwardedRef: ref
}));